
export default function AboutHistory() {
  const milestones = [
    {
      year: '2018',
      title: 'Foundation',
      description: 'Started as a small initiative to connect local entrepreneurs and provide mentorship opportunities.'
    },
    {
      year: '2019',
      title: 'First 100 Members',
      description: 'Reached our first milestone of 100 active members across 5 countries, establishing our core community.'
    },
    {
      year: '2020',
      title: 'Digital Transformation',
      description: 'Launched our digital platform and virtual programs, expanding our reach during global challenges.'
    },
    {
      year: '2021',
      title: 'Global Expansion',
      description: 'Expanded to 25 countries with over 1,000 members and launched our signature accelerator program.'
    },
    {
      year: '2022',
      title: 'Strategic Partnerships',
      description: 'Formed partnerships with leading corporations and institutions to enhance our service offerings.'
    },
    {
      year: '2023',
      title: 'Innovation Hub',
      description: 'Launched our innovation hub and reached 2,500+ members across 45+ countries worldwide.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Journey
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From humble beginnings to a global platform, discover the key milestones that shaped our growth and impact.
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-blue-200"></div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div key={index} className={`relative flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                {/* Timeline dot */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-lg z-10"></div>
                
                {/* Content */}
                <div className={`w-5/12 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                  <div className="bg-white rounded-lg p-6 shadow-lg">
                    <div className="text-2xl font-bold text-blue-600 mb-2">{milestone.year}</div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{milestone.title}</h3>
                    <p className="text-gray-600">{milestone.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
